<template>
    <div class="scroll-top" @click="scrollToTop">
        <i class="fa fa-arrow-up"></i>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {
        scrollToTop() {
            $('body, html').animate(
                {
                    scrollTop: '0px',
                },
                300
            )
        },
    },
    mounted() {
        $(window).scroll(function () {
            if ($(window).scrollTop() > 0) {
                $('.scroll-top').slideDown(300)
            } else {
                $('.scroll-top').slideUp(300)
            }
        })
    },
}
</script>
<style lang="css">
.scroll-top {
    display: none;
    padding: 20px;
    background: #ff761c;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 10000;
}
</style>
